import React, { useEffect, useMemo, useState } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import IconButton from '@mui/material/IconButton'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import TabsMui from '../../layout/TabsMui'
import PosDetailsTab from './PosDetailsTab'
import { layoutMobileMediaQuery } from '../../layout/layoutConstants'
import {
  POS_DETAILS_TAB_VALUE,
  POS_DETAILS_TABS,
  POS_DETAILS_TEXTS
} from './shared/posDetailsConstants'
import { getPosTaskStatusUI } from './shared/posDetailsHelpers'
import PosTaskStatusChip from '../PosTaskStatusChip'
import GoogleIcon from '../../components/icon/GoogleIcon'

const PosDetailsView = (props) => {
  const [showSuccessfulMessage, setShowSuccessfulMessage] = useState(false)
  const [activeTab, setActiveTab] = useState(POS_DETAILS_TAB_VALUE)
  const [activity, setActivity] = useState(props.defaultDetails)
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const returnToListPath = location.state?.from || '/ejecucion_punto_venta'

  useEffect(() => {
    setActivity(props.defaultDetails)
  }, [props.defaultDetails])

  useEffect(() => {
    setQueryParams()
  }, [])

  useEffect(() => {
    showSuccessfulMessageCreation()
  }, [])

  const showSuccessfulMessageCreation = () => {
    setShowSuccessfulMessage(document.referrer.includes('nuevo_pedido'))
  }

  const hiddenAlert = () => {
    setShowSuccessfulMessage(false)
  }

  const setQueryParams = () => {
    const success = searchParams.get('success') || ''
    if (success) {
      setShowSuccessfulMessage(true)
    }
  }

  const statusUI = useMemo(() => getPosTaskStatusUI(activity), [activity])
  const handleBackToList = () => {
    navigate(returnToListPath)
  }

  return (
    <>
      {showSuccessfulMessage && (
        <div className="alert alert-success d-flex justify-content-between align-items-center">
          <strong className="success-message">{POS_DETAILS_TEXTS.createdSuccessfully}</strong>
          <button
            type="button"
            className="btn-close"
            onClick={hiddenAlert}
            aria-label="Close"
          ></button>
        </div>
      )}
      <div className="main-show-header pos-details-main-header">
        <IconButton
          className="pos-details-main-header__back"
          onClick={handleBackToList}
          aria-label="Volver a tareas en punto de venta"
        >
          <GoogleIcon name="arrow_back" size={22} />
        </IconButton>
        <h2>
          {POS_DETAILS_TEXTS.headerTitlePrefix} {activity?.short_uuid}
        </h2>
      </div>
      <div className="index-table">
        <div className="show-area">
          <div className="show-area-tabs-header pos-details-tabs-header">
            <TabsMui
              tabs={POS_DETAILS_TABS}
              activeTab={activeTab}
              onChange={setActiveTab}
              showDivider={false}
              marginBottom={0}
            />
            <div className="status-orders pos-details-status-orders">
              {!isMobileLayout && <b className="order-status-b">{POS_DETAILS_TEXTS.statusLabel}</b>}
              <PosTaskStatusChip
                status={statusUI?.statusKey || activity?.status}
                className="pos-task-status--details"
              />
            </div>
          </div>
          <div className="tab-content-area">
            {activeTab === POS_DETAILS_TAB_VALUE && activity && (
              <PosDetailsTab
                activity={activity}
                transactionUuid={props.details?.uuid}
                onActivityChange={setActivity}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default PosDetailsView
